import SetPassword from "../Components/SetPassword";
import Title from "../Common/Title";
import { Flex } from "@chakra-ui/react";
import React, {useCallback, useState} from "react";
import { useSignUpProxy } from "../Custom Hooks/useSignUpProxy";
import Terms from "../Components/Terms";
import { useWrapper } from "../Context/WrapperContext";

export default function Password() {
  const [newPassword, setNewPassword] = useState("");
  const [reenterPassword, setReenterPassword] = useState("");
  const [isTOUed, setIsTOUed] = useState(false);
  const { decrement } = useWrapper();
  const handleCancel = useCallback(() => {
    setIsTOUed(false);
    decrement();
  }, [decrement]);

  const { createAction, pageLevelError } = useSignUpProxy({
    newPassword,
    reenterPassword,
    isTOUed,
  });
  return (
    <Flex direction="column" maxW={468} mx="auto">
      <Title text={"Create password"} />
      <SetPassword
        password={newPassword}
        setPassword={setNewPassword}
        retypePassword={reenterPassword}
        setRetypePassword={setReenterPassword}
        onContinue={createAction.act}
        onCancel={handleCancel}
        pageLevelError={pageLevelError}
        disableContinue={!isTOUed}
        termsElement={
          <Terms
            isTOUed={isTOUed}
            setIsTOUed={setIsTOUed}
          />
        }
      />
    </Flex>
  );
}
